import React, { useEffect, useState } from "react";

import Select from "components/general/Select";
import { getFlatEntitiesWithJobs } from "slices/jobs";
import { withTranslation } from "react-i18next";

const OfficeSelect = (props) => {
  const {
    jobBoard,
    officePermalink: propOfficePermalink,
    onChange,
    t,
    ...rest
  } = props;

  const [officePermalink, setOfficePermalink] = useState(null);
  const [flatOffices, setFlatOffices] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);

  // When the office permalink changes, update the state
  useEffect(() => {
    setOfficePermalink(propOfficePermalink);
  }, [propOfficePermalink]);

  // Once the job board is loaded, generate the office options
  useEffect(() => {
    const flatOfficesWithJobs = getFlatEntitiesWithJobs(jobBoard.flatOffices);

    const _officeOptions = [
      {
        label: t("All offices"),
        value: null,
      },
    ];
    for (const _office of flatOfficesWithJobs) {
      _officeOptions.push({
        label: _office.name,
        value: _office.permalink,
      });
      for (const officeChild of _office.flatChildren) {
        _officeOptions.push({
          label: officeChild.name,
          value: officeChild.permalink,
        });
      }
    }
    setOfficeOptions(_officeOptions);
    setFlatOffices(flatOfficesWithJobs);
  }, [jobBoard, t]);

  const selectedOfficeOption =
    officeOptions.find(
      (officeOption) => officeOption.value === officePermalink
    ) || officeOptions[0];

  // Determine which office permalinks are children and which have selected parents
  // We need to pass some data to the custom option component
  const _officeOptionData = {};
  if (flatOffices) {
    for (const _office of flatOffices) {
      _officeOptionData[_office.permalink] = {
        isChild: false,
      };
      for (const officeChild of _office.flatChildren) {
        _officeOptionData[officeChild.permalink] = {
          isChild: true,
          isParentSelected: selectedOfficeOption
            ? selectedOfficeOption.value === _office.permalink
            : false,
        };
      }
    }
  }

  return (
    <Select
      onChange={onChange}
      options={officeOptions}
      value={selectedOfficeOption}
      isSearchable={true}
      placeholder={"Location"}
      nestingData={_officeOptionData}
      {...rest}
    />
  );
};

export default withTranslation()(OfficeSelect);
